import mediaIndex from "./media-index.json";

export type MediaRole =
    | "editorial"
    | "miniApp"
    | "miniApp1"
    | "miniApp2"
    | "crm"
    | "crm1"
    | "crm2"
    | "site"
    | "site1"
    | "og";

type MediaAssets = Partial<Record<MediaRole, string>>;

const index = mediaIndex as Record<string, MediaAssets>;

export function getPageMedia(pageKey: string): MediaAssets {
    return index[pageKey] ?? {};
}

export function homeMedia(): MediaAssets {
    return getPageMedia("home");
}

export function presetMedia(slug: string): MediaAssets {
    return getPageMedia(`preset:${slug}`);
}

export function nicheMedia(nicheId: string): MediaAssets {
    return getPageMedia(`niche:${nicheId}`);
}

/** Prefer numbered role, then alias (miniApp1 → miniApp). */
export function mediaUrl(assets: MediaAssets, role: MediaRole, fallback?: string): string | undefined {
    return assets[role] ?? fallback;
}
